import { useState } from "react";
import { Helmet } from "react-helmet";
import "../styles/Testimonials.css";

const testimonials = [
  {
    name: "Richard T.",
    quote: "I've never felt stronger or more motivated. Lu - Fit's coaching is top tier!",
    rating: 5,
  },
  {
    name: "Susan M.",
    quote: "The online coaching program kept me accountable and in shape—even while traveling.",
    rating: 5,
  },
  {
    name: "Mark K.",
    quote: "I went from struggling with discipline to looking forward to every session. Highly recommend!",
    rating: 5,
  },
  {
    name: "Julia B.",
    quote: "House calls made it easy to fit training into my busy schedule. I love the flexibility!",
    rating: 5,
  },
  {
    name: "Anele Z.",
    quote: "Boxing workouts helped me lose weight and feel confident again. Thank you, Lu!",
    rating: 5,
  },
  {
    name: "Tinashe R.",
    quote: "1-on-1 sessions are perfectly tailored to my goals. Every session is worth it.",
    rating: 5,
  },
  {
    name: "Lerato M.",
    quote: "I've seen real progress in just a few weeks. Highly professional and fun environment!",
    rating: 5,
  },
  {
    name: "James D.",
    quote: "Lu - Fit turned my fitness life around. The results speak for themselves!",
    rating: 5,
  }
];

function Testimonials() {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const handlePrev = () => setCurrent((prev) => (prev === 0 ? total - 1 : prev - 1));
  const handleNext = () => setCurrent((prev) => (prev === total - 1 ? 0 : prev + 1));

  return (
    <section id="testimonials" aria-labelledby="testimonials-heading">
      <Helmet>
        <title>Client Testimonials | Lu - Fit Personal Training</title>
        <meta name="description" content="Read what clients are saying about our personal training, boxing, online coaching, and house call services." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Review",
            "itemReviewed": {
              "@type": "Organization",
              "name": "Lu - Fit Personal Training"
            },
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": testimonials[current].name
            },
            "reviewBody": testimonials[current].quote
          })}
        </script>
      </Helmet>

      <div className="testimonials-header">
        <h2 id="testimonials-heading" className="testimonials-subtitle-heading">
          What Our Clients Say
        </h2>
        <p className="testimonials-subtitle">
          Our clients trust Lu - Fit to guide them through their personal fitness journeys. Here's what they have to say.
        </p>
      </div>

      <div className="testimonial-slider" role="region" aria-roledescription="carousel" aria-label="Client testimonials">
        <figure className="testimonial-card" aria-label={`Testimonial from ${testimonials[current].name}`}>
          {[1, 2, 3, 4, 5].map((icon) => (
            <img
              src="/media/icons/star-icon.png"
              alt="5 star rating"
              width="100"
              height="20"
              loading="lazy"
              key={icon}
              className="testimonials-rating"
            />
          ))}
          <blockquote className="testimonial-quote">“{testimonials[current].quote}”</blockquote>
          <figcaption className="testimonial-author">~ {testimonials[current].name}</figcaption>
        </figure>

        <div className="testimonial-controls" aria-label="Testimonial navigation">
          <button onClick={handlePrev} aria-label="Previous testimonial" className="testimonial-nav-btn">‹</button>
          <span className="testimonial-index" aria-live="polite">
            {current + 1} / {total}
          </span>
          <button onClick={handleNext} aria-label="Next testimonial" className="testimonial-nav-btn">›</button>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
